import { request } from "../index"

export async function getCertificates() {
    return request({ "url": "certificates/" })
}
export async function uploadCertificate(file, password) {
    const data = new FormData();
    data.append("password", password);
    data.append("file", file);
    return request({ "url": `certificates/`, method: "POST", data })
}
export async function deactivate() {
    return request({ "url": `certificates/deactivate/`, method: "DELETE" })
}
export async function clickBuyCertificate() {
    return request({ "url": "buy-certificate-click/" })
}


// WEBPACK FOOTER //
// ./src/api/digitalCertificates/index.js